import axios from "../../../util/axios";

export default {
    /** 查询字典分类 */
    queryDictionaryTypes: () => axios.get({url: "/basedata/system/dictionary/queryDictionaryTypes"}),
    /** 查询列表，用于列表类 */
    queryList: (data) => axios.get({url: "/basedata/system/dictionary/queryList", data: data}),
    /** 查询列表，用于列表类 */
    queryParentList: (data) => axios.get({url: "/basedata/system/dictionary/queryParentList", data: data}),
    /** 查询树结构，用于树结构 */
    queryListAsTree: (type) => axios.get({url: "/basedata/system/dictionary/queryTree", data: {type}}),
    /** 查询树结构，用于树结构 */
    queryParentTree: (type) => axios.get({url: "/basedata/system/dictionary/queryParentTree", data: {type}}),
    /** 保存字典 */
    save: (data) => axios.post({url: "/basedata/system/dictionary/save", data: data}),
    /** 保存字典,树形字典 */
    saveTreeNode: (data) => axios.post({url: "/basedata/system/dictionary/saveTreeNode", data: data}),
    /** 删除数据 */
    deleteById: (data) => axios.del({url: "/basedata/system/dictionary/delete", data: data}),
    // 以下为自定义字段
    /** 查询有哪些服务 */
    queryDynamicService: () => axios.get({url: "/basedata/system/dictionary/queryDynamicService"}),
    /** 查询列表 */
    queryDynamicList: (data) => axios.get({url: "/basedata/system/dictionary/queryDynamicList", data: data}),
    /** 删除数据 */
    saveDynamic: (data) => axios.post({url: "/basedata/system/dictionary/saveDynamic", data: data}),
    /** 查询详情 */
    findDynamicDictionary: (id) => axios.get({url: "/basedata/system/dictionary/findDynamicDictionary", data: {id}}),
    /** 保存字典，唯一性字典 */
    saveUnique: (data) => axios.post({url: "/basedata/system/dictionary/saveUnique", data: data}),
    /** 保存字典,树形字典,唯一性字典 */
    saveUniqueTreeNode: (data) => axios.post({url: "/basedata/system/dictionary/saveUniqueTreeNode", data: data}),
    /** 删除唯一性字典 */
    deleteUnique: (dictType, id) => axios.del({url: "/basedata/system/dictionary/deleteUnique", data: {dictType, id}}),
    /** 查询唯一性列表，用于列表类 */
    queryUniqueList: (data) => axios.get({url: "/basedata/system/dictionary/queryUniqueList", data: data}),
    /** 查询唯一性树列表，用于列表类 */
    queryUniqueTree: (type, merchantId) => axios.get({url: "/basedata/system/dictionary/queryUniqueTree", data: {type, merchantId}}),



}